import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default class ParallaxLayer extends React.Component {
    static propTypes = {
        children: PropTypes.node,
        depth: PropTypes.number,
        height: PropTypes.number,
        width: PropTypes.number,
        noPointerEvents: PropTypes.bool
    };

    render() {
        const style = {};
        if (this.props.height && this.props.width) {
            style.height = this.props.height;
            style.width = this.props.width;
        }

        const {depth} = this.props;
        if (!depth || depth < 0 || depth > 1) {
            console.warn('ParallaxLayer expects depth to be a number between 0 and 1');
        }

        const classes = classNames('layer', {'no-pointer-events': this.props.noPointerEvents});

        return (
            <div className={classes} data-depth={depth} style={style}>
                {this.props.children}
            </div>
        );
    }
}
